import { Component, computed, inject, Signal } from '@angular/core';
import { shareLinkResource } from '@pages/share-link-page/share-link-page.component';
import { BuildingScanViewerDetailDto } from '@artemis-software/wr-api';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'wr-building-point-cloud-scan-share-link-page',
  templateUrl: './building-point-cloud-scan-share-link-page.component.html',
  styleUrls: ['./building-point-cloud-scan-share-link-page.component.scss'],
})
export class BuildingPointCloudScanShareLinkPageComponent {
  readonly sanitizer = inject(DomSanitizer);

  buildingScan = inject(shareLinkResource) as Signal<BuildingScanViewerDetailDto>;

  readonly buildingScanLink = computed<SafeResourceUrl | null>(() => {
    const scan = this.buildingScan();
    if (!scan?.pointCloudId) {
      return null;
    }

    const url = `https://benaco.com/embed/${scan.pointCloudId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });
}
